import React from 'react';
import classNames from 'classnames';
import styles from './forbes-logo-link.module.scss';

import { ForbesLogo } from '../../icons';

const ForbesLogoLink: React.FunctionComponent<{
  className?: string;
}> = ({
  className,
}) => {
  return (
    <a
      className={classNames(
        styles.component,
        className,
      )}
      href="https://www.forbes.ru/"
      title="Forbes.ru | Главное о миллиардерах, бизнесе, финансах и инвестициях в России и мире"
    >
      <ForbesLogo
        className={classNames(styles.logo)}
      />
    </a>
  );
}

export default ForbesLogoLink;
